import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "password-rule" }


import { CheckOutlined, MinusOutlined } from '@ant-design/icons-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordRule',
  props: {
    label: null,
    valid: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { label:string, valid:boolean };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.valid)
      ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
          key: 0,
          style: {"margin-right":"16px","color":"green"}
        }))
      : (_openBlock(), _createBlock(_unref(MinusOutlined), {
          key: 1,
          style: {"margin-right":"16px"}
        })),
    _createTextVNode(" " + _toDisplayString(props.label), 1)
  ]))
}
}

})